var _path, _path2, _path3, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrgan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Organ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.82 C17.1 2.82 21.18 7.24 21.18 12 C21.18 16.76 17.1 21.18 12 21.18 C8.6 21.18 5.88 19.48 4.86 17.1 C6.22 15.4 6.9 13.7 6.9 12 C6.9 10.3 6.22 8.6 4.86 6.9 C5.88 4.52 8.6 2.82 12 2.82 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9 12 L2.82 12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52 9.28 L6.56 10.64"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.82,
    cy: 12,
    r: 0.612,
    fill: "#FFFFFF",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgan);
export default __webpack_public_path__ + "static/media/organ.986b71c80c0b296b2eef99a91549d758.svg";
export { ForwardRef as ReactComponent };